module.exports = __webpack_public_path__ + "static/tag_icon-273ea76a5e44e5a2bd7b.png";